module.exports = __webpack_public_path__ + "img/1.24f2ac14.jpg";